export const isOrbitElliptical = (orbit) => orbit.e < 1;
export const isOrbitHyperbola = (orbit) => orbit.e >= 1;
//# sourceMappingURL=orbit.js.map